import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, of } from 'rxjs';
import { ContentDataSource } from './content-data-source';
import { InstitutionalPage, MisionVisionPage } from '../../models/institutional/institutional.model';
import { Banca, BancaDetail, Agency } from '../../models/institutional/banca.model';
import { SustainabilityReport } from '../../models/institutional/sustainability.model';

/**
 * JSON file-based content data source.
 * Reads from /content/institutional/*.json files.
 * Will be replaced by ApiContentDataSource when Strapi is integrated.
 */
@Injectable()
export class JsonContentDataSource extends ContentDataSource {
  private readonly basePath = '/content/institutional';

  constructor(protected readonly http: HttpClient) {
    super();
  }

  getPage(slug: string): Observable<InstitutionalPage> {
    return this.http.get<InstitutionalPage>(`${this.basePath}/${slug}.json`);
  }

  getMisionVision(): Observable<MisionVisionPage> {
    return this.http.get<MisionVisionPage>(`${this.basePath}/mision-vision.json`);
  }

  getSustainabilityReports(): Observable<SustainabilityReport[]> {
    return this.http.get<SustainabilityReport[]>(`${this.basePath}/sustainability-reports.json`);
  }

  getBancas(): Observable<Banca[]> {
    return this.http.get<{ bancas: Banca[] }>(`${this.basePath}/bancas.json`).pipe(map((response) => response.bancas));
  }

  getBancaDetail(slug: string): Observable<BancaDetail> {
    return this.http.get<{ bancas: BancaDetail[] }>(`${this.basePath}/bancas.json`).pipe(
      map((response) => {
        const banca = response.bancas.find((b) => b.slug === slug);
        if (!banca) {
          throw new Error(`Banca not found: ${slug}`);
        }
        return banca;
      })
    );
  }

  getAgencies(_: string): Observable<Agency[]> {
    // All agencies come from the CMS API — not available in the static JSON data source
    return of([]);
  }

  getAllAgencies(): Observable<Agency[]> {
    // All agencies come from the CMS API — not available in the static JSON data source
    return of([]);
  }
}
